/**
 * Provides some low-level boot task abstraction.
 * @module core/base/Booter
 */
import Backbone from "backbone";
import _ from "underscore";
import extend from "backbone-extend-standalone";
/**
 * Creates a new `Booter`.
 * @constructor
 */
function Booter() {
  _.extend(this, Backbone.Events);

  this.initialize();
}

Booter.prototype = {
  /**
   * Performs initialization of the web application.
   */
  initialize: function (app) {},

  /**
   * Loads the router classes and initializes them.
   * @protected
   * @abstract
   * @return {Promise} A promise object which resolves when all routers have been loaded.
   */
  loadCoreRouters: function () {},

  /**
   * Gets the URL path at which to initialize the routing system.
   * @abstract
   * @return {string} The initial path.
   */
  getBootPath: function () {
    if (!this._path) {
      this._path = this.createBootPath();
    }

    return this._path;
  },

  /**
   * Creates the lazy-loaded value returned by `getBootPath`.
   * @abstract
   * @protected
   * @return {string} The initial path.
   */
  createBootPath: function () {},

  /**
   * Performs the boot process.
   * @return {Promise} A promise object which resolves when the application has been fully booted.
   */
  boot: function () {
    var self = this;

    self.trigger("loading");

    return self
      .loadCoreRouters()
      .then(function () {
        self.trigger("loaded");
      })
      .then(function () {
        self.trigger("booting");

        var path = self.getBootPath();

        if (!(window.history && history.pushState)) {
          Backbone.history.start({
            pushState: false,
            silent: true,
          });
        } else {
          Backbone.history.start({
            pushState: true,
          });
        }

        if (path && path != "/") {
          _.defer(function () {
            Backbone.history.navigate(path, {
              trigger: true,
            });
            self.trigger("booted");
          });
        } else {
          self.trigger("booted");
        }
      });
  },
};

Booter.extend = extend;

export default Booter;



//////////////////
// WEBPACK FOOTER
// ./public/js/core/base/Booter.js
// module id = 588
// module chunks = 1